import React from 'react'
import { Input } from '@livechat/design-system'

const TextAnswer = ({ index, response, setResponse }) => {
  return (
    <Input
      value={response[index] || ''}
      placeholder="Type answer"
      onChange={(e) =>
        setResponse({
          ...response,
          [index]: e.target.value,
        })
      }
    />
  )
}

export default TextAnswer
